import type { BjAnniItem } from '../../apis/client-side/live/type';

export default function getSpecialDayLottieFileName(bjAnni: BjAnniItem) {
  switch (bjAnni.type) {
    case 'start':
      return `${bjAnni.days}${bjAnni.unit === 'year' ? 'year' : 'days'}.json`;
    case 'signature':
      return 'signature.json';
    case 'birth':
      return 'birthday.json';
    default:
      return bjAnni.type;
  }
}
